module.exports = {
  "local": {
    "firebase_config": {
      apiKey: "AIzaSyDDzkq95D8z8RYf-PzFrJRJML5s7WBxJt0",
      authDomain: "template-video-1a6fa.firebaseapp.com",
      projectId: "template-video-1a6fa",
      storageBucket: "template-video-1a6fa.appspot.com",
      messagingSenderId: "439458054165",
      appId: "1:439458054165:web:9d893e46b5db21a9004e1c",
      measurementId: "G-3VQK8VRJL7",
      domain: 'localhost:8080',
      video_domain: 'localhost:8080',
      api_domain: 'localhost:5000/template-video-1a6fa/us-central1/api-api',
    },
    "fullstory": {
      // org_id: 'YXMTA'
    },
    "hubspot": {
      // site_id: '8904915'
    },
    "segment": {
      // write_key: 'jUkj9H8xnw83trk9YjOfLMS6DH99auuQ'
    },
    "mixpanel": {
      // token: 'c055c12576b6132cdbae00e7a8721b49'
    }
  },
  "development-local": {
    "firebase_config": {
      apiKey: "AIzaSyDDzkq95D8z8RYf-PzFrJRJML5s7WBxJt0",
      authDomain: "template-video-1a6fa.firebaseapp.com",
      projectId: "template-video-1a6fa",
      storageBucket: "template-video-1a6fa.appspot.com",
      messagingSenderId: "439458054165",
      appId: "1:439458054165:web:9d893e46b5db21a9004e1c",
      measurementId: "G-3VQK8VRJL7",
      domain: 'template-video-1a6fa.web.app',
      video_domain: 'template-video-1a6fa.web.app',
      api_domain: 'localhost:5000/template-video-1a6fa/us-central1/api-api',
    },
    "fullstory": {
      // org_id: 'YXMTA'
    },
    "hubspot": {
      // site_id: '8904915'
    },
    "segment": {
      // write_key: 'jUkj9H8xnw83trk9YjOfLMS6DH99auuQ'
    },
    "mixpanel": {
      // token: 'c055c12576b6132cdbae00e7a8721b49'
    }
  },
  "development": {
    "firebase_config": {
      apiKey: "AIzaSyDDzkq95D8z8RYf-PzFrJRJML5s7WBxJt0",
      authDomain: "template-video-1a6fa.firebaseapp.com",
      projectId: "template-video-1a6fa",
      storageBucket: "template-video-1a6fa.appspot.com",
      messagingSenderId: "439458054165",
      appId: "1:439458054165:web:9d893e46b5db21a9004e1c",
      measurementId: "G-3VQK8VRJL7",
      domain: 'template-video-1a6fa.web.app',
      video_domain: 'template-video-1a6fa.web.app',
      api_domain: 'template-video-1a6fa.web.app',
    },
    "fullstory": {
      // org_id: 'YXMTA'
    },
    "hubspot": {
      // site_id: '8904915'
    },
    "segment": {
      // write_key: 'jUkj9H8xnw83trk9YjOfLMS6DH99auuQ'
    },
    "mixpanel": {
      // token: 'c055c12576b6132cdbae00e7a8721b49'
    }
  },
  "production": {
    "firebase_config": {
      apiKey: "AIzaSyDDzkq95D8z8RYf-PzFrJRJML5s7WBxJt0",
      authDomain: "template-video-1a6fa.firebaseapp.com",
      projectId: "template-video-1a6fa",
      storageBucket: "template-video-1a6fa.appspot.com",
      messagingSenderId: "439458054165",
      appId: "1:439458054165:web:9d893e46b5db21a9004e1c",
      measurementId: "G-3VQK8VRJL7",
      domain: 'template-video-1a6fa.web.app',
      video_domain: 'template-video-1a6fa.web.app',
      api_domain: 'template-video-1a6fa.web.app',
    },
    "fullstory": {
      org_id: 'YXMTA'
    },
    "hubspot": {
      site_id: '8904915'
    },
    "segment": {
      write_key: 'jUkj9H8xnw83trk9YjOfLMS6DH99auuQ'
    },
    "mixpanel": {
      token: 'c055c12576b6132cdbae00e7a8721b49'
    }
  }
}
